const PropTypes = require('prop-types');
const FooterLinkModel = require('./FooterLinkModel');

class FooterColumnModel {
  constructor() {
    this.title = null;
    this.items = [];
  }
  deserialise(data) {
    this.title = data.primary.title;
    this.items = (data.items || []).map(item => new FooterLinkModel()
      .deserialise(item));
    return this;
  }
}

FooterColumnModel.propTypes = PropTypes.shape({
  items: PropTypes.arrayOf(FooterLinkModel.propTypes),
  title: PropTypes.string,
});

module.exports = FooterColumnModel;



// WEBPACK FOOTER //
// ./src/common/models/prismic/components/FooterColumnModel.js